module.exports = require("cytoscape-edge-editing");